import {
  calculateItemTotal
} from "../utils/offer.utils";

const getValue = (
  item,
  camel,
  snake
) => {
  return (
    item[camel] ??
    item[snake] ??
    0
  );
};

const OfferItemsTable = ({
  items = [],
  currency = "INR",
  onEdit,
  onDelete,
  readOnly = false
}) => {
  if (!items.length) {
    return (
      <div className="offer-items-table__empty">
        No offer items added.
      </div>
    );
  }

  return (
    <div className="offer-items-table">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Description</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Discount</th>
            <th>Tax</th>
            <th>Total</th>

            {!readOnly && (
              <th>Actions</th>
            )}
          </tr>
        </thead>

        <tbody>
          {items.map(
            (item, index) => {
              const quantity =
                getValue(
                  item,
                  "quantity",
                  "quantity"
                );

              const unitPrice =
                getValue(
                  item,
                  "unitPrice",
                  "unit_price"
                );

              const discountAmount =
                getValue(
                  item,
                  "discountAmount",
                  "discount_amount"
                );

              const taxAmount =
                getValue(
                  item,
                  "taxAmount",
                  "tax_amount"
                );

              const calculated =
                calculateItemTotal({
                  quantity,
                  unitPrice,
                  discountAmount,
                  taxAmount
                });

              return (
                <tr key={
                  item.id || index
                }>
                  <td>
                    {index + 1}
                  </td>

                  <td>
                    <strong>
                      {
                        item.description
                      }
                    </strong>

                    {item.offering_name && (
                      <small>
                        {
                          item.offering_name
                        }
                      </small>
                    )}
                  </td>

                  <td>
                    {quantity}
                  </td>

                  <td>
                    {currency}{" "}
                    {Number(
                      unitPrice
                    ).toFixed(2)}
                  </td>

                  <td>
                    {currency}{" "}
                    {Number(
                      discountAmount
                    ).toFixed(2)}
                  </td>

                  <td>
                    {currency}{" "}
                    {Number(
                      taxAmount
                    ).toFixed(2)}
                  </td>

                  <td>
                    <strong>
                      {currency}{" "}
                      {Number(
                        calculated.totalAmount
                      ).toFixed(2)}
                    </strong>
                  </td>

                  {!readOnly && (
                    <td>
                      {onEdit && (
                        <button
                          type="button"
                          onClick={() =>
                            onEdit(item)
                          }
                        >
                          Edit
                        </button>
                      )}

                      {onDelete && (
                        <button
                          type="button"
                          onClick={() =>
                            onDelete(item)
                          }
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OfferItemsTable;